import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import chartUtils from '../../../util/chartUtils';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';
import ZoomControlButton from '../../../components/ZoomControlButton';

import AvgThroughput from './AvgThroughput';
import ThroughputHistogramChart from './ThroughputHistogramChart';

import '../ThroughputHistogram.scss';

class WallboardThroughputHistogramChart extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Throughput Histogram</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="th" showAvgChart options={{ avgChartTooltip: 'Throughput averages' }} />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          {this.props.avgChart && (chartUtils.hasValues(this.props.data) ? (
            <AvgThroughput
              data={this.props.data}
              excludeZeroDays={this.props.excludeZeroDays}
              dateFormat={this.props.dateFormat}
            />
          ) : (
            <CardPlaceholder title="Throughput averages" shape="line" loading={this.props.isLoading} />
          ))}
        </div>
        <div className="diagram_details">
          <ZoomControlButton chart="th" />
          <ThroughputHistogramChart id="ThroughputHistogram" data={this.props.data} />
          <NoData show={!chartUtils.hasValues(this.props.data)} loading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    avgChart: state.filters.th.avgChart,
    excludeZeroDays: state.filters.th.excludeZeroDays,
    data: state.throughputHistogram.data,
    isLoading: state.throughputHistogram.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardThroughputHistogramChart);
